import { useState, useCallback } from "react";

export type ContentType = string | null;

type UseModalReturnType = {
  isOpen: boolean;
  openModal: () => void;
  closeModal: () => void;
  contentType: ContentType;
};

export const useModal = (): UseModalReturnType => {
  const [isOpen, setIsOpen] = useState(false);
  const [contentType, setContentType] = useState<ContentType>(null);

  const openModal = useCallback(() => {
    setIsOpen(true);
    setContentType(contentType);
  }, [contentType]);

  const closeModal = useCallback(() => {
    setIsOpen(false);
    setContentType(null);
  }, []);

  return {
    isOpen,
    contentType,
    openModal,
    closeModal,
  };
};
